import { render } from "./tooltip.vue?vue&type=template&id=08ccaf52"
import script from "./tooltip.vue?vue&type=script&lang=js"
export * from "./tooltip.vue?vue&type=script&lang=js"

import "./tooltip.vue?vue&type=style&index=0&id=08ccaf52&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__